import {
    changeIdle,
    changeVisibility,
} from '../actions/app'
import {Action} from '@reduxjs/toolkit'
import {Middleware} from 'redux'
import ninchatClient from '../api/NinchatClient'
import {updateSession} from '../api/action/updateSession'

export const appMiddleware: Middleware = (store) => {
    const DELAYED_DISPATCH_TIMEOUT_IN_SECONDS = 3

    let isIdle = false

    let delayedDispatchTimeoutId: ReturnType<typeof setTimeout> // eslint-disable-line init-declarations

    const dispatch = (action: Action, shouldIdle: boolean) => {
        isIdle = shouldIdle
        store.dispatch(action)
    }

    const delayedDispatch = (action: Action, shouldIdle: boolean): any => {
        delayedDispatchTimeoutId = setTimeout(() => dispatch(action, shouldIdle), DELAYED_DISPATCH_TIMEOUT_IN_SECONDS * 1000)
    }

    const setIdle = (shouldIdle: boolean, shouldDelay = false) => {
        if (!ninchatClient.connected) {
            return
        }

        clearTimeout(delayedDispatchTimeoutId)

        if (shouldIdle !== isIdle) {
            const _dispatch = shouldDelay ? delayedDispatch : dispatch
            _dispatch(updateSession({session_idle: shouldIdle}) as any, shouldIdle)
        }
    }

    return (next) => (action) => {
        switch (action.type) {
            case changeIdle.type:
                setIdle(action.payload)
                return next(action)
            case changeVisibility.type:
                setIdle(!action.payload, true)
                return next(action)
            default:
                return next(action)
        }
    }
}
